import Postmate from 'postmate'
import { getDynamicSettings } from '../utils/browserStructure'

let registrationShadowHandshake, registrationShadow, shadowHolder

export function openRegistrationShadow ({ url: shadowRegistrationUrl, successCallback }) {
  if (registrationShadow) return registrationShadow

  if (!shadowHolder) {
    shadowHolder = document.createElement('div')
    shadowHolder.id = 'shadow-holder'

    // Hide shadow registration
    shadowHolder.style.position = 'absolute'
    shadowHolder.style.top = '10000px'
    shadowHolder.style.left = '10000px'

    document.body.appendChild(shadowHolder)
  }

  registrationShadowHandshake = registrationShadowHandshake || new Postmate({
    container: shadowHolder,
    url: shadowRegistrationUrl + '?isAffiliate=true'
  }).then(connection => {
    registrationShadow = connection

    successCallback && successCallback()
  })
}

export function isShadowRegistration () {
  return !!registrationShadow
}

export function shadowCallback (type, { data, dataDiff }) {
  const typeCapitalized = type.charAt(0).toUpperCase() + type.slice(1)
  const callbackProp = `regily${typeCapitalized}Callback`

  registrationShadow.call(`${callbackProp}Data`, { data, dataDiff })

  return new Promise((resolve, reject) => {
    registrationShadow.get(callbackProp).then((response) => {
      console.info(`${type} callback resolved on proxy`)

      const errorData = response && response.error
      if (errorData) {
        const { name, title, message } = errorData
        const error = new Error(message)
        error.name = name
        error.title = title
        reject(error)
        return
      }

      resolve(response)
    })
  })
}

export function runRegistrationShadowPostmate () {
  const handshake = new Postmate.Model({
    data: {},
    dataDiff: {},
    dynamicSettings: getDynamicSettings(),
    regilyUpdateCallbackData: ({ data, dataDiff }) => {
      handshake.data = data
      handshake.dataDiff = dataDiff
    },
    regilyUpdateCallback: () => new Promise((resolve) => {
      const isCallbackPresent = typeof window['regilyUpdateCallback'] === 'function'

      if (isCallbackPresent) {
        window['regilyUpdateCallback'](handshake.data, handshake.dataDiff).then(response => {
          resolve(response)
        }, error => {
          const errorResponse = {
            error: {}
          }
          errorResponse.error = Object.assign({}, error)
          errorResponse.error.message = error.message

          resolve(errorResponse)
        })
      }
    }),
    regilyDoneCallbackData: ({ data, dataDiff }) => {
      handshake.data = data
    },
    regilyDoneCallback: () => new Promise((resolve) => {
      const isCallbackPresent = typeof window['regilyCallback'] === 'function' || typeof window['regilyDoneCallback'] === 'function'

      if (isCallbackPresent) {
        window['regilyDoneCallback'](handshake.data).then(response => {
          resolve(response)
        }, error => {
          const errorResponse = {
            error: {}
          }
          errorResponse.error = Object.assign({}, error)
          errorResponse.error.message = error.message

          resolve(errorResponse)
        })
      }
    })
  })
}



// WEBPACK FOOTER //
// ./src/partners/remote.js